import React, { useState, useEffect } from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import { useTranslation } from 'react-i18next';

const ODatePickerWithRange = (props) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = ([date]) => {
    setStartDate(date);
    props.handleDateChange(date, endDate || date);
  };

  const handleEndDateChange = ([date]) => {
    setEndDate(date);
    props.handleDateChange(startDate, date);
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
  };

  useEffect(() => {
    if (props?.isReset) {
      handleReset();
      props?.setIsReset(false);
    }
  }, [props?.isReset]);

  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        <Flatpickr
          className="block py-2 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none focus:outline-none focus:ring-0 cursor-pointer"
          name="start_date"
          placeholder={t("START_DATE")}
          value={startDate}
          options={{
            dateFormat: "Y-m-d",
            altFormat: "M d, Y",
            altInput: true,
          }}
          onChange={handleStartDateChange}
        />
      </div>
      <span className="text-gray-400">—</span>
      <div className="relative">
        <Flatpickr
          className="block py-2 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none focus:outline-none focus:ring-0 cursor-pointer"
          name="end_date"
          placeholder={t("END_DATE")}
          value={endDate}
          options={{
            dateFormat: "Y-m-d",
            altFormat: "M d, Y",
            altInput: true,
            minDate: startDate || null,
          }}
          onChange={handleEndDateChange}
        />
      </div>
    </div>
  );
};

export default ODatePickerWithRange;